<script lang="ts">
  import type { CustomComponent } from '$shared/components/types';

  interface Props {
    label?: string;
    customFooter?: CustomComponent;
  }

  let { label = '', customFooter = null }: Props = $props();
</script>

<div class="entity-footer">
  {#if customFooter?.component}
    {@const SvelteComponent = customFooter?.component}
    <SvelteComponent {...customFooter?.props || {}} />
  {:else if label}
    <div class="footer-content">{label}</div>
  {:else}
    <div class="footer-content">Invalid Footer</div>
  {/if}
</div>

<style>
  .entity-footer {
    padding-top: 16px;
  }
</style>
